export const NotificationCategory = {
  Product: 'product',
  Billing: 'billing',
  Reports: 'reports',
};

export const NotificationType = {
  Update: 'update',
  PageReport: 'page-report',
  RenderLimit75: 'render-limit-75',
  RenderLimit100: 'render-limit-100',
  RenderLimitTrial100: 'render-limit-100-trial',
  RenderLimitTrial115: 'render-limit-115-trial',
  BetterPlanFound: 'better-plan-found',
  PriceUpdate2026: 'price-update-2026',
  PriceUpdate2026Trial: 'price-update-2026-trial',
  Text: 'text',
};

export type NotificationCategoryType = typeof NotificationCategory[keyof typeof NotificationCategory];
type NotificationTypeType = typeof NotificationType[keyof typeof NotificationType];

type Notification = {
  id: string;
  description: string;
  category: NotificationCategoryType;
  type: NotificationTypeType;
  metadata: Record<string, any>; // TODO: define metadata types
  createdAt: string;
  seenAt?: string;
};

export default Notification;
